import React from "react";
import glamorous from "glamorous";
import { color } from "../../style/index";

const buttonDefault = {
  backgroundColor: "white",
  border: "none",
  color: color.BRAND_1
};

const buttonPurple = {
  backgroundColor: color.BRAND_1,
  border: "none",
  color: "white"
};

const buttonPurpleDark = {
  backgroundColor: color.BRAND_1_DARK,
  border: `2px solid ${color.BRAND_1}`,
  color: color.BRAND_1
};

const buttonStyle = type => {
  switch (type) {
    case "purple":
      return buttonPurple;
    case "purple-dark":
      return buttonPurpleDark;
    default:
      return buttonDefault;
  }
};

const Button = glamorous.button(
  {
    borderRadius: 26
  },
  ({ height, width, buttonType }) => ({
    height: height ? height : null,
    width: width ? width : "auto",
    ":focus": { outline: "none" },
    ...buttonStyle(buttonType)
  })
);

const Content = glamorous.span({
  display: "flex",
  justifyContent: "center"
});

const ButtonRound = props => {
  const {
    buttonType,
    height,
    width,
    otherStyles,
    ...rest
  } = props;

  return (
    <Button
      height={height}
      width={width}
      buttonType={buttonType}
      {...otherStyles}
      {...rest}
    >
      <Content>{props.children}</Content>
    </Button>
  );
};

export default ButtonRound;



// WEBPACK FOOTER //
// ./src/components/blocks/ButtonRound.jsx